GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.fsCount = 0;
  this.trialProgressionCount = [0, 0, 0, 0, 0, 0];
  this.force = undefined;
  this._coinValue = 100;
  this.cheatAdded = false;

  this.currentMode = 'BASIC';

  this.persistenceNameMapOLDtoNEW = {
    'jp freespins': 'J',
    'elimination spins': 'E',
    freespins: 'F',
    wheel: 'W',
    numFreeSpins: 'C',
    megaJackpot: '1',
    porkerJackpot: '2',
    majorJackpot: '3',
    maxiJackpot: '4',
    minorJackpot: '5',
    miniJackpot: '6',
    totalUpgrades: 'U',
    featureDisplayLevelIndex: 'I',
    awardedPigs: 'P',
    eliminationLevel: 'L',
    featureState: 'F',
    features: 'F',
    lastCashStake: 'B',
    lastGameMode: 'M',
  };

  this.persistenceNameMapOLDtoOLD = {
    'jp freespins': 'jp freespins',
    'elimination spins': 'elimination spins',
    freespins: 'freespins',
    wheel: 'wheel',
    numFreeSpins: 'numFreeSpins',
    megaJackpot: 'megaJackpot',
    porkerJackpot: 'porkerJackpot',
    majorJackpot: 'majorJackpot',
    maxiJackpot: 'maxiJackpot',
    minorJackpot: 'minorJackpot',
    miniJackpot: 'miniJackpot',
    totalUpgrades: 'totalUpgrades',
    featureDisplayLevelIndex: 'featureDisplayLevelIndex',
    awardedPigs: 'awardedPigs',
    eliminationLevel: 'eliminationLevel',
    featureState: 'featureState',
    features: 'features',
    lastCashStake: 'lastCashStake',
    lastGameMode: 'lastGameMode',
  };

  this.persistenceNameMap = this.persistenceNameMapOLDtoOLD;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inLuckyBet = false;
  this._localRngSeed = -1;
  this._endGame = false;

  this.defaultPersistanceData = undefined;

  this.freeSpinsCostMaxMultiplier;
  this.freeSpinsCostMultiplier;
  this.luckyBetCostMultiplier;

  this._totalWinnings = 0;

  // this.loadLanguageFiles = undefined; // delete me when translations are ready

  // Track current display state
  this._currentDisplayState = {
    green: {
      displayLevelIndex: 0,
      eliminationLevel: 0,
    },
    red: {
      displayLevelIndex: 0,
      numFreeSpins: 0,
    },
    gold: {
      displayLevelIndex: 0,
      numWheelUpgrades: 1,
    },
    blue: {
      displayLevelIndex: 0,
      jackpotPots: { jpMega: 1250000, jpPorker: 75000, jpMajor: 1750, jpMaxi: 1000, jpMinor: 750, jpMini: 250 },
    },
  };

  // Show pending display states
  this._pendingDisplayStateUpdate = {
    postBase: {
      changes: null,
      afterPart: null,
    },
    postWheel: {
      changes: null,
      afterPart: null,
    },
    postFeature: {
      changes: null,
      afterPart: null,
    },
  };

  this._isWheel = false;
  this._isFeatureSpins = false;

  //PERSISTENCE
  this._initialPersistentValues = {}; // recovery and forces or just forces
  this._persistentValues = {};
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.getRandomForGui = function () {
  let rangeExplicit = 32768; // it is the default inside the mersenneTwister but in case they change it I am defining it here
  let r = MarsenneTwister.rand(rangeExplicit);
  let res = r / rangeExplicit;
  return res;
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    'LEFT_TOP',
    ['playerState']
  );
};

// Override subscribeEvents to use our custom updateGameBalance prototype method
// GatiServerGame.prototype.subscribeEvents = function (slot) {
//   const self = this;
//
//   // First, call the base implementation to get all standard callbacks
//   GatiServer.prototype.subscribeEvents.call(this, slot);
//
//   // Override the updateGameBalance callback to call our prototype method
//   slot.subscribeOnEvents({
//     updateGameBalance: (balance) => {
//       self.updateGameBalance(balance);
//     },
//   });
// };

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    const maxStake = sc.isMaxStake();
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.requestNextSpinOutcome = function (cb) {
  this.logCheatString();
  let outcome = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData;
  let playerState = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.playerState;
  if (this.cheatAdded || this.isRestore) {
    if (this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData.InitialGameState) {
      this.initialPlayerState =
        this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData.InitialGameState;
    } else {
      this.initialPlayerState = this.defaultPersistanceData;
    }
  } else {
    this.initialPlayerState =
      this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.initialPlayerState !== undefined
        ? this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.initialPlayerState
        : this.defaultPersistanceData;
  }
  if (this.cheatPanelActive) {
    this.cheat = this._latestEngineReponse.wager.bets[this._currentBetData].betdata.cheat;
  }
  // if (this.force !== '' && !this.inFS) {
  //   this.updateInitialPlayerStateFromCheatString();
  // }
  // if (this.force !== '' && !this.inFS) {
  //   this.updateInitialPlayerStateFromCheatString();
  // }
  this.getSpinData(cb, outcome, playerState, this.initialPlayerState);
};

// GatiServer.prototype.updateInitialPlayerStateFromCheatString = function () {
//   if (this.initialPlayerState !== undefined && this.cheat !== 'null') {
//     const force = this.force;
//     const respins = parseInt(force.s.match(/R(\d+)/)[1], 10);
//     const coins = parseInt(force.s.match(/A(\d+)/)[1], 10);
//     const initialPlayerState = JSON.parse(this.initialPlayerState.state);
//

//     if (
//       initialPlayerState.CloverProgress[this.currentMode] &&
//       initialPlayerState.CloverProgress[this.currentMode][this._stake]
//     ) {
//       initialPlayerState.CloverProgress[this.currentMode][this._stake].RespinsCount = respins;
//       initialPlayerState.CloverProgress[this.currentMode][this._stake].ActivationCount = coins;
//     }
//     this.initialPlayerState.state = JSON.stringify(initialPlayerState);
//     this.restoreCounterData(this.initialPlayerState, undefined);
//   }
// };

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot.getGameEventsEmitter().gameReady({ defaultBetValue: this._stake / 100 });
    console.log('Gati Platform: Restore Mode set to ' + readyResponse.restoreMode);
    // no longer modal
    messageBus.post('game:modal', { data: 'Platform Ready To Start' });
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === 'RESTORE';
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame({ stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines }, self._isRecoveryGame);

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      // SRB - Balance
      // self.addBalanceEventToQueue();
      // self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate('common:GameCommitted');
    } else if (readyResponse.restoreMode === 'SKIP') {
      const stakeInfo = self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      const finalIndex = this._previousWagers.data[0].bets.length - 1;
      const initialPlayerState =
        this._previousWagers.data[0].bets[finalIndex].eventdata.initialPlayerState !== undefined
          ? this._previousWagers.data[0].bets[finalIndex].eventdata.initialPlayerState
          : this.defaultPersistanceData;
      const playerState = this._previousWagers.data[0].bets[finalIndex].eventdata.playerState;
      if (playerState !== undefined) {
        this.updatePersistentState(initialPlayerState, playerState, this.currentMode);
        this.restoreCounterData(initialPlayerState, playerState);
      }
      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      // SRB - Balance
      // self.addBalanceEventToQueue();
      messageBus.postImmediate('common:GameSkipped', stakeInfo);
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      let license = this._license;
      if (license === '' || license === undefined) {
        license = 'default';
      } else {
        license = license.toUpperCase();
      }

      // Brazil specific, show help page if the game is not in replay mode and the license is BR
      if (license === 'BR') {
        gameData.helpPageScroll.open();
      }

      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);

      if (gameData.previouslyLoadedStakeAndMode?.lastCashStake != null) {
        if (
          gameData.previouslyLoadedStakeAndMode.lastGameMode === 0 ||
          gameData.previouslyLoadedStakeAndMode.lastGameMode === 1
        ) {
          // only change stake if its a valid one
          self.changeStake(gameData.previouslyLoadedStakeAndMode.lastCashStake);
        }
      }
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post('game:modal', {
    reason: 'Waiting on Platform',
    data: 'Waiting on Platform',
  });

  informGameReady(this._slotGame);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  // im seeing a lot of floating points in this game e.g. 700.000000000001
  // should we use trunc instead of floor?
  res.baseStake = Math.floor(res.baseStake);
  res.stake = Math.floor(res.stake);

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === 'GOLDENBET_BUY'
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.getPreviousMapSelection = function () {
  let res = '';

  // this._isRecoveryGame gets cleared once finalised
  if (this._inRewatchMode || this._inReplayMode || this._isRecoveryGame) {
    const nextBetIndex = this._currentBetData + 1;
    if (
      this._previousWagers &&
      this._previousWagers.data &&
      this._previousWagers.data.length > 0 &&
      this._previousWagers.data[0].bets &&
      this._previousWagers.data[0].bets.length > nextBetIndex &&
      this._previousWagers.data[0].bets[nextBetIndex].betdata.cmd.indexOf('PICKMAP_') !== -1
    ) {
      res = this._previousWagers.data[0].bets[nextBetIndex].betdata.cmd;
    }
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.isRestore = loadData.mode === 'RESTORE';
  let data = JSON.stringify(loadData);
  // console.log(data);
  // if (this._inReplayMode === true && this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true) {
  //   this.prepaidInitialBalance = parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
  //   this.prepaidResultBalance = parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  // }
  this.cheatPanelActive = loadData.customParameters.cheatPanel === 'yes';
  this.addGameConfigToQueueBase(loadData);
  this.defaultPersistanceData =
    loadData.settings.gameFeatures !== undefined &&
    loadData.settings.gameFeatures.playerState !== undefined &&
    loadData.settings.gameFeatures.playerState.playerState !== undefined
      ? loadData.settings.gameFeatures.playerState.playerState
      : this.defaultPersistanceData;

  let message = this._messageQueue[0];
  message.buyBonusCost = 100;
  gdk.addConfigValue('AllowBuyBonus', message.slotConfig.gameModes['BONUS_BUY_LOW'] ? true : false);

  let firstEverGame = false;

  if (loadData.settings.gameFeatures?.playerState?.playerState === undefined) {
    firstEverGame = true;
  }

  let configMessage = this._messageQueue[this._messageQueue.length - 1];
  configMessage.firstEverGame = firstEverGame;

  if (configMessage.slotConfig.gameModes.BONUS_BUY_LOW) {
    this.freeSpinsCostMultiplierLow = configMessage.slotConfig.gameModes.BONUS_BUY_LOW.coinsPerBet / 100;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_HIGH) {
    this.freeSpinsCostMultiplierHigh = configMessage.slotConfig.gameModes.BONUS_BUY_HIGH.coinsPerBet / 100;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_MYSTERY) {
    this.freeSpinsCostMultiplierMystery = configMessage.slotConfig.gameModes.BONUS_BUY_MYSTERY.coinsPerBet / 100;
  }

  configMessage.buyBonusCostFreeSpinsLow = this.freeSpinsCostMultiplierLow;
  configMessage.buyBonusCostFreeSpinsHigh = this.freeSpinsCostMultiplierHigh;
  configMessage.buyBonusCostFreeSpinsMystery = this.freeSpinsCostMultiplierMystery;

  configMessage.minimalSpinningTime = loadData.settings.minimalSpinningTime;
  configMessage.slotConfig.inReplayMode = this._inReplayMode;
  gameData.recoveryStake = undefined;
  configMessage.slotConfig.coins = 20; // purely paytable
  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;
  // configMessage.defaultMapPicks = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].defaultMapPicks;

  // persistence
  const slotConfig = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig;
  const defaultFeatureState = slotConfig.defaultFeatureState;

  if (!defaultFeatureState['jp freespins']) {
    this.persistenceNameMap = this.persistenceNameMapOLDtoNEW;
  }

  const jackpotData = defaultFeatureState[this.persistenceNameMap['jp freespins']];
  const fsData = defaultFeatureState[this.persistenceNameMap['freespins']];
  const elimData = defaultFeatureState[this.persistenceNameMap['elimination spins']];
  const wheelData = defaultFeatureState[this.persistenceNameMap['wheel']];

  // Jackpot Data
  configMessage.megaJackpot = jackpotData[this.persistenceNameMap['megaJackpot']];
  configMessage.porkerJackpot = jackpotData[this.persistenceNameMap['porkerJackpot']];
  configMessage.majorJackpot = jackpotData[this.persistenceNameMap['majorJackpot']];
  configMessage.maxiJackpot = jackpotData[this.persistenceNameMap['maxiJackpot']];
  configMessage.minorJackpot = jackpotData[this.persistenceNameMap['minorJackpot']];
  configMessage.miniJackpot = jackpotData[this.persistenceNameMap['miniJackpot']];
  configMessage.totalUpgrades = jackpotData[this.persistenceNameMap['totalUpgrades']];

  // Free Spins Data
  configMessage.numFreeSpins = fsData[this.persistenceNameMap['numFreeSpins']];

  // Pig levels
  configMessage.redPigLevel = fsData[this.persistenceNameMap['featureDisplayLevelIndex']];
  configMessage.bluePigLevel = jackpotData[this.persistenceNameMap['featureDisplayLevelIndex']];
  configMessage.greenPigLevel = elimData[this.persistenceNameMap['featureDisplayLevelIndex']];
  configMessage.goldPigLevel = wheelData[this.persistenceNameMap['featureDisplayLevelIndex']];
  configMessage.awardedPigs = wheelData[this.persistenceNameMap['awardedPigs']];

  this.luckyBetCostMultiplier = configMessage.slotConfig.gameModes.GOLDENBET_BUY.coinsPerBet;

  configMessage.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;
  configMessage.buyLuckyBet = this.luckyBetCostMultiplier;

  if (
    configMessage.slotConfig.gameModes['BONUS_BUY_LOW'] ||
    configMessage.slotConfig.gameModes['BONUS_BUY_HIGH'] ||
    configMessage.slotConfig.gameModes['BONUS_BUY_MYSTERY']
  ) {
    allowBonusBuy = true;
  }

  if (
    loadData.customParameters.buyBonusDisabled === 'yes' ||
    loadData.customParameters.buyBonusDisabled === 'Yes' ||
    loadData.customParameters.license === 'uk' ||
    loadData.customParameters.license === 'fin' ||
    loadData.customParameters.license === 'lt' ||
    loadData.customParameters.license === 'nl' ||
    loadData.customParameters.license === 'de'
  ) {
    allowBonusBuy = false;
  }

  /**
   *
   * PERSISTENCE
   *
   */
  let persistentState;
  let usePlayerDataAsDefaults = false;

  if (this._inRewatchMode || this._inReplayMode || loadData.mode === 'RESTORE') {
    let bets = loadData.wagers.data[0].bets;
    for (let i = 0; i < bets.length; ++i) {
      let bet = bets[i];

      if (loadData.mode === 'RESTORE') {
        // when restoring we should be using InitialGameState
        persistentState = bet.eventdata.response.clientData.InitialGameState;
        break;
      } else if (bet.eventdata && bet.eventdata.initialPlayerState) {
        persistentState = JSON.parse(bet.eventdata.initialPlayerState.state);
        break;
      }
    }
    if (!this.defaultPersistanceData) {
      this.defaultPersistanceData = {
        state: JSON.stringify({
          F: {
            F: {
              Basic: {
                '-1': defaultFeatureState,
              },
            },
          },
        }),
      };
    }
  } else {
    // Check if we have actual player data
    const gameFeatures = loadData.settings.gameFeatures;
    const playerStateData = gameFeatures?.playerState;

    if (playerStateData && playerStateData.playerState && playerStateData.playerState.state) {
      // Existing player with real persistent data
      persistentState = JSON.parse(playerStateData.playerState.state);
      usePlayerDataAsDefaults = true;
      console.log('Using existing player data as defaults');
    } else {
      // New user
      usePlayerDataAsDefaults = false;
      persistentState = undefined;
      console.log('New user detected - using default feature state values');
      this.defaultPersistanceData = {
        state: JSON.stringify({
          F: {
            F: {
              Basic: {
                '-1': defaultFeatureState,
              },
            },
          },
        }),
      };
    }
  }

  // Helper function to get persistent value from player data or fallback to defaults
  // Only use player data for the specific stake/mode combination, not as universal defaults
  const getPersistentValue = (stake, mode, featureName, propertyName, serverDefaultValue) => {
    if (
      persistentState &&
      persistentState[this.persistenceNameMap['featureState']] &&
      persistentState[this.persistenceNameMap['featureState']][this.persistenceNameMap['features']]
    ) {
      // Check server data using case-insensitive comparison because the server is sending
      // 'Basic' rather than 'BASIC' for example.
      const features = persistentState[this.persistenceNameMap['featureState']][this.persistenceNameMap['features']];
      let modeData = null;
      for (const serverMode in features) {
        if (serverMode.toUpperCase() === mode.toUpperCase()) {
          modeData = features[serverMode];
          break;
        }
      }
      if (modeData && modeData[stake] && modeData[stake][this.persistenceNameMap[featureName]]) {
        const value = modeData[stake][this.persistenceNameMap[featureName]][this.persistenceNameMap[propertyName]];
        if (value !== undefined) {
          return value;
        }
      }
    }
    // Always fall back to server defaults for unplayed stakes
    return serverDefaultValue;
  };

  // if we are in a prepaid game, we should really ignore the last state
  // and use the prepaid info instead
  const prepaidInfo = this._slotGame.getWagerHelper().getPrepaidInfo();
  if (prepaidInfo.isPrepaid === true) {
    gameData.previouslyLoadedStakeAndMode = {
      lastCashStake: prepaidInfo.betValue * 100,
      lastGameMode: 'BASIC',
    };
  } else if (persistentState != null) {
    const lastCashStake = persistentState[this.persistenceNameMap['lastCashStake']];
    const lastGameMode = persistentState[this.persistenceNameMap['lastGameMode']];

    const gameModes = ['BASIC', 'GOLDENBET_BUY', 'BONUS_BUY_LOW', 'BONUS_BUY_HIGH', 'BONUS_BUY_MYSTERY'];
    const mode = gameModes[lastGameMode];
    if (mode != null) {
      if (mode != 'GOLDENBET_BUY' || !loadData.settings.isGoldenBetDisabled) {
        const coinSizes = configMessage.slotConfig.gameModes?.[mode]?.coinSizes;
        if (coinSizes != null) {
          const winlineCount = configMessage.slotConfig.defaultNumLines;
          const validStakes = coinSizes.map((coinSize) => {
            return coinSize * winlineCount;
          });
          if (validStakes.includes(lastCashStake)) {
            gameData.previouslyLoadedStakeAndMode = {
              lastCashStake,
              lastGameMode,
            };
          }
        }
      }
    }
  }

  // Was used to display recovery stake immediately on load
  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Math.floor(parseFloat(betData.coin) * 10000);
    gameData.recoveryStake = stake;
    if (betData.cmd === 'GOLDENBET_BUY') {
      gameData.recoveryStake *= 1.5;
      gameData.recoveryMode = 'GOLDENBET_BUY';
    } else if (betData.cmd === 'BONUS_BUY_LOW') {
      gameData.recoveryMode = 'BONUS_BUY_LOW';
    } else if (betData.cmd === 'BONUS_BUY_HIGH') {
      gameData.recoveryMode = 'BONUS_BUY_HIGH';
    } else if (betData.cmd === 'BONUS_BUY_MYSTERY') {
      gameData.recoveryMode = 'BONUS_BUY_MYSTERY';
    }
  }

  // Get default values from server config
  const serverDefaults = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.defaultFeatureState;

  // Server defaults should be used for any stake/mode combination that hasn't been played
  // We'll pass these to getPersistentValue which will check for player-specific overrides

  let defaultModeIndex = 0;

  this._currency = loadData.settings.currency;

  let gameModeStrings = ['BASIC', 'GOLDENBET_BUY', 'BONUS_BUY_LOW', 'BONUS_BUY_HIGH', 'BONUS_BUY_MYSTERY', 'default'];
  let gameModes = [];
  for (let i = 0; i < Object.keys(configMessage.slotConfig.gameModes).length; ++i) {
    gameModes.push(Object.keys(configMessage.slotConfig.gameModes)[i]);
    this._persistentValues[gameModeStrings[i]] = {};
    this._initialPersistentValues[gameModeStrings[i]] = {};
  }

  const coinSizes = configMessage.slotConfig.coinSizes;
  const winlineCount = configMessage.slotConfig.defaultNumLines;
  const validStakes = coinSizes.map((coinSize) => {
    return coinSize * winlineCount;
  });

  let totalStakes = [];
  for (let i = 0; i < validStakes.length; ++i) {
    totalStakes.push(validStakes[i]);
  }

  const reverseNameMap = {
    BASIC: 'Basic',
    GOLDENBET_BUY: 'GoldenBet',
    BONUS_BUY_LOW: 'BonusBuyLow',
    BONUS_BUY_HIGH: 'BonusBuyHigh',
    BONUS_BUY_MYSTERY: 'BonusBuyMystery',
    default: 'default',
  };

  for (let i = 0; i < gameModes.length; ++i) {
    let gameMode = gameModeStrings[i];

    for (let j = 0; j < totalStakes.length; ++j) {
      let totalStake = totalStakes[j];

      if (gameMode === 'GOLDENBET_BUY') {
        totalStake *= 1.5;
      } else if (gameMode === 'BONUS_BUY_LOW') {
        totalStake *= this.freeSpinsCostMultiplierLow;
      } else if (gameMode === 'BONUS_BUY_HIGH') {
        totalStake *= this.freeSpinsCostMultiplierHigh;
      } else if (gameMode === 'BONUS_BUY_MYSTERY') {
        totalStake *= this.freeSpinsCostMultiplierMystery;
      }

      // old way!!!
      // Get values specific to this stake and mode combination
      // Use server defaults as fallbacks for unplayed stakes
      this._persistentValues[gameMode]['Stake_' + totalStake] = {
        freeSpinsNum: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'freespins',
          'numFreeSpins',
          serverDefaults[this.persistenceNameMap['freespins']][this.persistenceNameMap['numFreeSpins']]
        ),
        eliminationLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'elimination spins',
          'eliminationLevel',
          serverDefaults[this.persistenceNameMap['elimination spins']][this.persistenceNameMap['eliminationLevel']]
        ),
        redPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'freespins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['freespins']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        bluePigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        greenPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'elimination spins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['elimination spins']][
            this.persistenceNameMap['featureDisplayLevelIndex']
          ]
        ),
        goldPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'wheel',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['wheel']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        megaJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'megaJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['megaJackpot']]
        ),
        porkerJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'porkerJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['porkerJackpot']]
        ),
        majorJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'majorJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['majorJackpot']]
        ),
        maxiJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'maxiJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['maxiJackpot']]
        ),
        minorJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'minorJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['minorJackpot']]
        ),
        miniJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'miniJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['miniJackpot']]
        ),
        totalUpgrades: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'totalUpgrades',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['totalUpgrades']]
        ),
        awardedPigs: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'wheel',
          'awardedPigs',
          serverDefaults[this.persistenceNameMap['wheel']][this.persistenceNameMap['awardedPigs']]
        ),
      };

      this._initialPersistentValues[gameMode]['Stake_' + totalStake] = {
        freeSpinsNum: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'freespins',
          'numFreeSpins',
          serverDefaults[this.persistenceNameMap['freespins']][this.persistenceNameMap['numFreeSpins']]
        ),
        eliminationLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'elimination spins',
          'eliminationLevel',
          serverDefaults[this.persistenceNameMap['elimination spins']][this.persistenceNameMap['eliminationLevel']]
        ),
        redPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'freespins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['freespins']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        bluePigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        greenPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'elimination spins',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['elimination spins']][
            this.persistenceNameMap['featureDisplayLevelIndex']
          ]
        ),
        goldPigLevel: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'wheel',
          'featureDisplayLevelIndex',
          serverDefaults[this.persistenceNameMap['wheel']][this.persistenceNameMap['featureDisplayLevelIndex']]
        ),
        megaJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'megaJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['megaJackpot']]
        ),
        porkerJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'porkerJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['porkerJackpot']]
        ),
        majorJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'majorJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['majorJackpot']]
        ),
        maxiJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'maxiJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['maxiJackpot']]
        ),
        minorJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'minorJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['minorJackpot']]
        ),
        miniJackpot: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'miniJackpot',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['miniJackpot']]
        ),
        totalUpgrades: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'jp freespins',
          'totalUpgrades',
          serverDefaults[this.persistenceNameMap['jp freespins']][this.persistenceNameMap['totalUpgrades']]
        ),
        awardedPigs: getPersistentValue(
          totalStake,
          reverseNameMap[gameMode],
          'wheel',
          'awardedPigs',
          serverDefaults[this.persistenceNameMap['wheel']][this.persistenceNameMap['awardedPigs']]
        ),
      };
    }
  }

  let gcMessage = this._messageQueue[this._messageQueue.length - 1];
  if (persistentState !== undefined && persistentState.lastGameMode !== undefined) {
    if (loadData.settings.isGoldenBetDisabled && persistentState.lastGameMode === 1) {
      persistentState.lastGameMode = 0;
      gameController.isGoldenbetNowInvalid = true;
    }
    configMessage.slotConfig.lastGameMode = persistentState.lastGameMode;
    gcMessage.lastGameMode = persistentState.lastGameMode;
  } else {
    configMessage.slotConfig.lastGameMode = defaultModeIndex;
    gcMessage.lastGameMode = defaultModeIndex;
  }
  configMessage.slotConfig.persistentValues = this._persistentValues;
};

GatiServerGame.prototype.updatePersistentValue = function (stake, state, mode, origMode) {
  const featureState = state[this.persistenceNameMap['featureState']];
  const features = featureState[this.persistenceNameMap['features']];
  if (features.hasOwnProperty(origMode)) {
    if (features[origMode].hasOwnProperty(stake)) {
      const stakeProp = 'Stake_' + stake;
      if (!this._persistentValues[mode][stakeProp]) {
        // we dont have an entry for this stake
        this._persistentValues[mode][stakeProp] = {};
        // lets add one
      }

      if (this._persistentValues[mode][stakeProp]) {
        if (stake === 100) {
          console.log('persistent values', this._persistentValues);
          if (gameData.slotConfig !== undefined) {
            console.log('slotconfig Persistent values', gameData.slotConfig.persistentValues);
          }
        }
        const stakeData = features[origMode][stake];
        const jackpotData = stakeData[this.persistenceNameMap['jp freespins']];
        const fsData = stakeData[this.persistenceNameMap['freespins']];
        const elimData = stakeData[this.persistenceNameMap['elimination spins']];
        const wheelData = stakeData[this.persistenceNameMap['wheel']];

        const persistentValue = this._persistentValues[mode][stakeProp];

        persistentValue.freeSpinsNum = fsData[this.persistenceNameMap['numFreeSpins']];
        persistentValue.eliminationLevel = elimData[this.persistenceNameMap['eliminationLevel']];
        persistentValue.redPigLevel = fsData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.bluePigLevel = jackpotData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.greenPigLevel = elimData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.goldPigLevel = wheelData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.megaJackpot = jackpotData[this.persistenceNameMap['megaJackpot']];
        persistentValue.porkerJackpot = jackpotData[this.persistenceNameMap['porkerJackpot']];
        persistentValue.majorJackpot = jackpotData[this.persistenceNameMap['majorJackpot']];
        persistentValue.maxiJackpot = jackpotData[this.persistenceNameMap['maxiJackpot']];
        persistentValue.minorJackpot = jackpotData[this.persistenceNameMap['minorJackpot']];
        persistentValue.miniJackpot = jackpotData[this.persistenceNameMap['miniJackpot']];
        persistentValue.totalUpgrades = jackpotData[this.persistenceNameMap['totalUpgrades']];
        persistentValue.awardedPigs = wheelData[this.persistenceNameMap['awardedPigs']];
      }
    }
  }
};

GatiServerGame.prototype.updateInitialPersistentValue = function (stake, state, mode, origMode) {
  const featureState = state[this.persistenceNameMap['featureState']];
  const features = featureState[this.persistenceNameMap['features']];
  if (features.hasOwnProperty(origMode)) {
    if (features[origMode].hasOwnProperty(stake)) {
      const stakeProp = 'Stake_' + stake;

      if (this._initialPersistentValues[mode][stakeProp]) {
        if (stake === 100) {
          console.log('initialPersistentValues values', this._initialPersistentValues);
        }

        const stakeData = features[origMode][stake];
        const jackpotData = stakeData[this.persistenceNameMap['jp freespins']];
        const fsData = stakeData[this.persistenceNameMap['freespins']];
        const elimData = stakeData[this.persistenceNameMap['elimination spins']];
        const wheelData = stakeData[this.persistenceNameMap['wheel']];

        const persistentValue = this._initialPersistentValues[mode][stakeProp];

        persistentValue.freeSpinsNum = fsData[this.persistenceNameMap['numFreeSpins']];
        persistentValue.eliminationLevel = elimData[this.persistenceNameMap['eliminationLevel']];
        persistentValue.redPigLevel = fsData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.bluePigLevel = jackpotData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.greenPigLevel = elimData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.goldPigLevel = wheelData[this.persistenceNameMap['featureDisplayLevelIndex']];
        persistentValue.megaJackpot = jackpotData[this.persistenceNameMap['megaJackpot']];
        persistentValue.porkerJackpot = jackpotData[this.persistenceNameMap['porkerJackpot']];
        persistentValue.majorJackpot = jackpotData[this.persistenceNameMap['majorJackpot']];
        persistentValue.maxiJackpot = jackpotData[this.persistenceNameMap['maxiJackpot']];
        persistentValue.minorJackpot = jackpotData[this.persistenceNameMap['minorJackpot']];
        persistentValue.miniJackpot = jackpotData[this.persistenceNameMap['miniJackpot']];
        persistentValue.totalUpgrades = jackpotData[this.persistenceNameMap['totalUpgrades']];
        persistentValue.awardedPigs = wheelData[this.persistenceNameMap['awardedPigs']];
      }
    }
  }
};

GatiServerGame.prototype.updatePersistentState = function (initState, playerState, mode) {
  let gameModeStrings = ['Basic', 'GoldenBet', 'BonusBuyLow', 'BonusBuyHigh', 'BonusBuyMystery'];
  let nameMap = {
    Basic: 'BASIC',
    GoldenBet: 'GOLDENBET_BUY',
    BonusBuyLow: 'BONUS_BUY_LOW',
    BonusBuyHigh: 'BONUS_BUY_HIGH',
    BonusBuyMystery: 'BONUS_BUY_MYSTERY',
  };

  // should we only do this if we are recovery?
  if (initState !== undefined && (this._isRecoveryGame || this.cheatAdded)) {
    let initialState = typeof initState.state === 'string' ? JSON.parse(initState.state) : initState;
    for (let i = 0; i < gameModeStrings.length; i++) {
      if (
        initialState[this.persistenceNameMap['featureState']][this.persistenceNameMap['features']].hasOwnProperty(
          gameModeStrings[i]
        )
      ) {
        let stake = initialState[this.persistenceNameMap['lastCashStake']];
        if (this._isRecoveryGame) {
          stake = gameData.recoveryStake;
        } else {
          if (gameData.encoreEnabled && gameModeStrings[i] === 'GoldenBet') {
            stake *= 1.5;
          } else if (this.buyBonusLowActive && gameModeStrings[i] === 'BonusBuyLow') {
            stake *= this.freeSpinsCostMultiplierLow;
          } else if (this.buyBonusHighActive && gameModeStrings[i] === 'BonusBuyHigh') {
            stake *= this.freeSpinsCostMultiplierHigh;
          } else if (this.buyBonusMysteryActive && gameModeStrings[i] === 'BonusBuyMystery') {
            stake *= this.freeSpinsCostMultiplierMystery;
          }
        }

        if (this.cheatAdded || this._isRecoveryGame) {
          this.updateInitialPersistentValue(stake, initialState, nameMap[gameModeStrings[i]], gameModeStrings[i]);
        } else {
          this.updatePersistentValue(stake, initialState, nameMap[gameModeStrings[i]], gameModeStrings[i]);
        }
      }
    }
  }

  // should we be doing the below if we are recovery?
  // no i dont think we should, but i do feel as though the bottom bit is done at the end, perhaps
  // include it in the game complete / ended whatever its called
  if (!this._isRecoveryGame) {
    if (playerState !== undefined) {
      let newState = JSON.parse(playerState.state);
      const featureState = newState[this.persistenceNameMap['featureState']];
      let found = false;
      for (let i = 0; i < gameModeStrings.length; i++) {
        const features = featureState[this.persistenceNameMap['features']];
        if (features.hasOwnProperty(gameModeStrings[i])) {
          let stake = newState[this.persistenceNameMap['lastCashStake']];
          if (gameData.encoreEnabled && gameModeStrings[i] === 'GoldenBet') {
            stake *= 1.5;
          } else if (this.buyBonusLowActive && gameModeStrings[i] === 'BonusBuyLow') {
            stake *= this.freeSpinsCostMultiplierLow;
          } else if (this.buyBonusHighActive && gameModeStrings[i] === 'BonusBuyHigh') {
            stake *= this.freeSpinsCostMultiplierHigh;
          } else if (this.buyBonusMysteryActive && gameModeStrings[i] === 'BonusBuyMystery') {
            stake *= this.freeSpinsCostMultiplierMystery;
          }
          this.updatePersistentValue(stake, newState, nameMap[gameModeStrings[i]], gameModeStrings[i]);
          found = true;
        }
      }

      if (!found) {
        // mismatch in caps
      }
    }
  } else {
    // // TODO: this needs to be done at the end of the game
    if (playerState !== undefined) {
      this.playerStateToApplyAtEndOfGameBecauseOfRecovery = JSON.parse(playerState.state);
    }
  }
};

GatiServerGame.prototype.updatePersistentStateForEndGameWhenRecovery = function (playerState) {
  let gameModeStrings = ['Basic', 'GoldenBet', 'BonusBuyLow', 'BonusBuyHigh', 'BonusBuyMystery'];
  let nameMap = {
    Basic: 'BASIC',
    GoldenBet: 'GOLDENBET_BUY',
    BonusBuyLow: 'BONUS_BUY_LOW',
    BonusBuyHigh: 'BONUS_BUY_HIGH',
    BonusBuyMystery: 'BONUS_BUY_MYSTERY',
  };

  for (let i = 0; i < gameModeStrings.length; i++) {
    const features = playerState[this.persistenceNameMap['featureState']][this.persistenceNameMap['features']];
    if (features.hasOwnProperty(gameModeStrings[i])) {
      let stake = playerState[this.persistenceNameMap['lastCashStake']];
      if (gameData.encoreEnabled && gameModeStrings[i] === 'GoldenBet') {
        stake *= 1.5;
      } else if (this.buyBonusLowActive && gameModeStrings[i] === 'BonusBuyLow') {
        stake *= this.freeSpinsCostMultiplierLow;
      } else if (this.buyBonusHighActive && gameModeStrings[i] === 'BonusBuyHigh') {
        stake *= this.freeSpinsCostMultiplierHigh;
      } else if (this.buyBonusMysteryActive && gameModeStrings[i] === 'BonusBuyMystery') {
        stake *= this.freeSpinsCostMultiplierMystery;
      }
      this.updatePersistentValue(stake, playerState, nameMap[gameModeStrings[i]], gameModeStrings[i]);
    }
  }
};

GatiServerGame.prototype.updatePersistentValuesFromDisplayState = function (displayStateAfterPart, stake, mode) {
  return;
  // Update the persistent values for the current stake and mode with the new display state
  if (this._persistentValues[mode] && this._persistentValues[mode]['Stake_' + stake]) {
    const persistentEntry = this._persistentValues[mode]['Stake_' + stake];

    // Update pig levels
    persistentEntry.redPigLevel = displayStateAfterPart.freeSpinsDisplayLevelIndex;
    persistentEntry.bluePigLevel = displayStateAfterPart.jpSpinsDisplayLevelIndex;
    persistentEntry.greenPigLevel = displayStateAfterPart.eliminationsDisplayLevelIndex;
    persistentEntry.goldPigLevel = displayStateAfterPart.wheelDisplayLevelIndex;

    // Update feature values
    persistentEntry.freeSpinsNum = displayStateAfterPart.numFreeSpins;
    persistentEntry.eliminationLevel = displayStateAfterPart.eliminationLevel;

    // Update jackpot values if present
    if (displayStateAfterPart.jackpotPots) {
      persistentEntry.megaJackpot = displayStateAfterPart.jackpotPots.jpMega;
      persistentEntry.porkerJackpot = displayStateAfterPart.jackpotPots.jpPorker;
      persistentEntry.majorJackpot = displayStateAfterPart.jackpotPots.jpMajor;
      persistentEntry.maxiJackpot = displayStateAfterPart.jackpotPots.jpMaxi;
      persistentEntry.minorJackpot = displayStateAfterPart.jackpotPots.jpMinor;
      persistentEntry.miniJackpot = displayStateAfterPart.jackpotPots.jpMini;
    }

    // Update total upgrades if present
    if (displayStateAfterPart.totalUpgrades !== undefined) {
      persistentEntry.totalUpgrades = displayStateAfterPart.totalUpgrades;
    }

    // Update awarded pigs if present
    if (displayStateAfterPart.numWheelUpgrades !== undefined) {
      persistentEntry.awardedPigs = displayStateAfterPart.numWheelUpgrades;
    }

    console.log(`Updated persistent values for ${mode} Stake_${stake}:`, persistentEntry);
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  this.addingRecoveryToQueue = true;
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'GOLDENBET_BUY') {
      this.currentMode = 'GOLDENBET_BUY';
      gameData.encoreEnabled = true;
      this._inLuckyBet = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_LOW') {
      this._inBuyABonus = true;
      this.buyBonusLowActive = true;
      this.currentMode = 'BONUS_BUY_LOW';
      this._meta = {
        name: 'buyABonusFreeSpinsLow',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_HIGH') {
      this._inBuyABonus = true;
      this.buyBonusHighActive = true;
      this.currentMode = 'BONUS_BUY_HIGH';
      this._meta = {
        name: 'buyABonusFreeSpinsHigh',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_MYSTERY') {
      this._inBuyABonus = true;
      this.buyBonusMysteryActive = true;
      this.currentMode = 'BONUS_BUY_MYSTERY';
      this._meta = {
        name: 'buyABonusFreeSpinsMystery',
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this.addingRecoveryToQueue = false;
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inLuckyBet = stakeData.metaData.encore;

  this.buyBonusLowActive = stakeData.metaData.buyBonusLowActive || false;
  this.buyBonusMysteryActive = stakeData.metaData.buyBonusMysteryActive || false;
  this.buyBonusHighActive = stakeData.metaData.buyBonusHighActive || false;

  if (this._forces === undefined || !this._forces) {
    this._forces = '';
    this.addCheatToRequest(stakeData, this._forces);
  }

  this._finalWheelWinnings = 0;
  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  this.currentMode = 'BASIC';

  if (this._forces === '' && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  if (this._inLuckyBet) {
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.coins = this.luckyBetCostMultiplier;
    this.currentMode = 'GOLDENBET_BUY';
    request.cmd = 'GOLDENBET_BUY';
  } else if (this._inBuyABonus) {
    if (this.buyBonusMysteryActive) {
      baseStake = stakeController.getBaseStake('BONUS_BUY_MYSTERY') / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierMystery;
      request.coin = baseStake / this._coinValue;
      this.currentMode = 'BONUS_BUY_MYSTERY';
      request.cmd = 'BONUS_BUY_MYSTERY';
    } else if (this.buyBonusHighActive) {
      baseStake = stakeController.getBaseStake('BONUS_BUY_HIGH') / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierHigh;
      request.coin = baseStake / this._coinValue;
      this.currentMode = 'BONUS_BUY_HIGH';
      request.cmd = 'BONUS_BUY_HIGH';
    } else {
      baseStake = stakeController.getBaseStake('BONUS_BUY_LOW') / 100;
      request.amount = baseStake * this.freeSpinsCostMultiplierLow;
      request.coin = baseStake / this._coinValue;
      this.currentMode = 'BONUS_BUY_LOW';
      request.cmd = 'BONUS_BUY_LOW';
    }
  }
};

GatiServerGame.prototype.addFSStartToQueue = function (data, mode) {
  this.fsWinnings = 0;
  var message = {};
  let shutterData = data.spins.spins;
  let shutterInfo = [];
  message.type = 'spinner:FreeSpinsStartEvent';
  message.featureType = data.featureType;
  message.freeSpinsAwarded = data.spins.spins.length;
  message.mode = mode;
  message.eliminationLevel =
    data.eliminationsLevel !== -1 ? data.eliminationsLevel : data.gameDisplayStateAfterPart.eliminationLevel;
  shutterData.map((spin) => {
    // Process each shutter and add the original symbol from the corresponding reel position
    let processedShutters = spin.shutters.shutters.map((shutter) => {
      // Get the original symbol from the stopWindow at the shutter's position
      let originalSymbol = null;
      if (
        spin.stopWindow &&
        spin.stopWindow.reelList &&
        spin.stopWindow.reelList[shutter.pos.reel] &&
        spin.stopWindow.reelList[shutter.pos.reel].symbols &&
        spin.stopWindow.reelList[shutter.pos.reel].symbols[shutter.pos.row]
      ) {
        originalSymbol = spin.stopWindow.reelList[shutter.pos.reel].symbols[shutter.pos.row].value;
      }

      // Return the shutter with the originalSymbol property added
      let modifiedShutterInfo = { ...shutter, originalSymbol: originalSymbol };
      return modifiedShutterInfo;
    });

    shutterInfo.push(processedShutters);
  });
  message.shutterInfo = shutterInfo;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function (data) {
  let message = {};
  message.type = 'spinner:FreeSpinsDataEvent';
  message.num = this.fsCount + 1;
  message.winAmountSoFar = data.winAmountSoFar;
  message.spinWinAmount = data.spinWinAmount;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = 'spinner:FreeSpinsEndEvent';
  message.fsWinnings = winnings;
  message.totalWinnings = this._totalWinnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

GatiServerGame.prototype.buildDisplayStateChanges = function (parts) {
  this._pendingDisplayStateUpdate.postBase.changes = null;
  this._pendingDisplayStateUpdate.postBase.afterPart = null;
  this._pendingDisplayStateUpdate.postWheel.changes = null;
  this._pendingDisplayStateUpdate.postWheel.afterPart = null;
  this._pendingDisplayStateUpdate.postFeature.changes = null;
  this._pendingDisplayStateUpdate.postFeature.afterPart = null;

  const baseGamePart = parts.find((part) => part.type === 'baseGame');
  const wheelPart = parts.find((part) => part.type === 'wheel');
  const featureSpinsPart = parts.find((part) => part.type === 'featureSpins');

  const baseDisplayAfterPart = baseGamePart?.gameDisplayStateAfterPart;
  const wheelDisplayAfterPart = wheelPart?.gameDisplayStateAfterPart;
  const featureDisplayAfterPart = featureSpinsPart?.gameDisplayStateAfterPart;

  if (baseGamePart) {
    // get post base display state changes
    this._pendingDisplayStateUpdate.postBase.changes = this.checkDisplayStateChanges(
      this._currentDisplayState,
      this.transformDisplayStateAfterPart(baseDisplayAfterPart)
    );
    this._pendingDisplayStateUpdate.postBase.afterPart = baseDisplayAfterPart;
  }

  // get post wheel display state changes
  if (wheelDisplayAfterPart) {
    this._pendingDisplayStateUpdate.postWheel.changes = this.checkDisplayStateChanges(
      this.transformDisplayStateAfterPart(baseGamePart ? baseDisplayAfterPart : this._currentDisplayState),
      this.transformDisplayStateAfterPart(wheelDisplayAfterPart)
    );
    this._pendingDisplayStateUpdate.postWheel.afterPart = wheelDisplayAfterPart;
  }

  // get post feature display state changes
  if (featureDisplayAfterPart) {
    this._pendingDisplayStateUpdate.postFeature.changes = this.checkDisplayStateChanges(
      this.transformDisplayStateAfterPart(wheelPart ? wheelDisplayAfterPart : baseDisplayAfterPart),
      this.transformDisplayStateAfterPart(featureDisplayAfterPart)
    );
    this._pendingDisplayStateUpdate.postFeature.afterPart = featureDisplayAfterPart;
  }
};

GatiServerGame.prototype.restoreCounterData = function (initialPlayerState, playerState) {
  var message = {};
  message.state = this._persistentValues;
  message.initialPlayerState = initialPlayerState;
  message.playerState = playerState;
  message.type = 'game:restoreCountersEvent';
  this._messageQueue.push(message);
};

// Build a message which will be picked up by gameController to update client
// via updateCounters(data)
GatiServerGame.prototype.addPersistentValuesUpdateToQueue = function (stake, mode) {
  var message = {};
  message.type = 'game:updatePersistentValuesEvent';
  message.initialState = this._initialPersistentValues;
  message.state = this._persistentValues;
  message.stake = stake;
  message.mode = mode;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addCheatUpdatePigDisplay = function (initialGameState, stake, mode) {
  var message = {};
  message.type = 'game:updatePiggiesBecauseOfForceEvent';
  message.initialState = this._initialPersistentValues;
  message.state = this._persistentValues;
  message.stake = stake;
  message.mode = mode;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data, playerState, initialPlayerState) {
  let parts = data.Parts;
  let wasRestore = this.isRestore;

  if (this.inFS) {
    this.getSpinDataFS(parts[0], cb);
    return;
  } else {
    this.updatePersistentState(initialPlayerState, playerState, this.currentMode);
    if (this.isRestore) {
      //create stake change message with initialPlayerState
      this.isRestore = false;
      // this.restoreCounterData(initialPlayerState, playerState);
    }
  }

  const featureState = this._persistentValues[this.currentMode]; // data.InitialGameState.featureState.features.Basic;
  if (!featureState['Stake_' + data.Stake]) {
    // && wasRestore) {
    // we dont have persistence data for this stake or this mode
    // probably restore 1st bonus buy on an org which has different stakes for bonus buy
    // compared to normal
    let nameMap = {
      BASIC: 'Basic',
      GOLDENBET_BUY: 'GoldenBet',
      BONUS_BUY_LOW: 'BonusBuyLow',
      BONUS_BUY_HIGH: 'BonusBuyHigh',
      BONUS_BUY_MYSTERY: 'BonusBuyMystery',
    };
    const defaultData = JSON.parse(this.defaultPersistanceData.state);
    const features = defaultData[this.persistenceNameMap['featureState']][this.persistenceNameMap['features']];
    const mode = features[nameMap[this.currentMode]] ? features[nameMap[this.currentMode]] : features[nameMap.BASIC];
    const pData = wasRestore
      ? mode[data.Stake]
        ? mode[data.Stake]
        : mode[-1]
      : mode[data.Stake]
        ? mode[data.Stake]
        : mode[-1];
    const jackpotData = pData[this.persistenceNameMap['jp freespins']];
    const fsData = pData[this.persistenceNameMap['freespins']];
    const elimData = pData[this.persistenceNameMap['elimination spins']];
    const wheelData = pData[this.persistenceNameMap['wheel']];

    featureState['Stake_' + data.Stake] = {
      freeSpinsNum: fsData[this.persistenceNameMap['numFreeSpins']],
      eliminationLevel: elimData[this.persistenceNameMap['eliminationLevel']],
      redPigLevel: fsData[this.persistenceNameMap['featureDisplayLevelIndex']],
      bluePigLevel: jackpotData[this.persistenceNameMap['featureDisplayLevelIndex']],
      greenPigLevel: elimData[this.persistenceNameMap['featureDisplayLevelIndex']],
      goldPigLevel: wheelData[this.persistenceNameMap['featureDisplayLevelIndex']],
      megaJackpot: jackpotData[this.persistenceNameMap['megaJackpot']],
      porkerJackpot: jackpotData[this.persistenceNameMap['porkerJackpot']],
      majorJackpot: jackpotData[this.persistenceNameMap['majorJackpot']],
      maxiJackpot: jackpotData[this.persistenceNameMap['maxiJackpot']],
      minorJackpot: jackpotData[this.persistenceNameMap['minorJackpot']],
      miniJackpot: jackpotData[this.persistenceNameMap['miniJackpot']],
      totalUpgrades: jackpotData[this.persistenceNameMap['totalUpgrades']],
      awardedPigs: wheelData[this.persistenceNameMap['awardedPigs']],
    };
  }
  const featureStateForStake = featureState['Stake_' + data.Stake];

  this._currentDisplayState.green.displayLevelIndex = featureStateForStake.greenPigLevel;
  this._currentDisplayState.green.eliminationLevel = featureStateForStake.eliminationLevel;
  this._currentDisplayState.red.displayLevelIndex = featureStateForStake.redPigLevel;
  this._currentDisplayState.red.numFreeSpins = featureStateForStake.freeSpinsNum;
  this._currentDisplayState.gold.displayLevelIndex = featureStateForStake.goldPigLevel;
  this._currentDisplayState.blue.displayLevelIndex = featureStateForStake.bluePigLevel;

  this.buildDisplayStateChanges(parts);

  if (this.buyBonusLowActive) {
    // fire event to force the free spins pot to be 9
    messageBus.postImmediate('game:buyBonusLowActive');
  } else if (this.buyBonusHighActive) {
    // fire event to force the free spins pot to be 15
    messageBus.postImmediate('game:buyBonusHighActive');
  } else if (this.buyBonusMysteryActive) {
    // fire event to force the free spins pot to be 9
    messageBus.postImmediate('game:buyBonusMysteryActive');
  }

  this._finalWheelWinnings = 0;
  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;

  let totalWon = 0;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    this._forces = '';
    this._localRngSeed = -1;

    if (type === 'baseGame') {
      if (this.cheatAdded === true) {
        this.cheatAdded = false;
        // first message we get
        // should force the piggie counters to reflect the cheat
        this.addCheatUpdatePigDisplay(data.InitialGameState, data.BasicStake, this.currentMode);
      }

      this._finalBaseWinnings = parts[i].winAmount;
      totalWon += this.getSpinDataNormal(parts[i], parts[i + 1]);
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }

      this.basicStake = data.BasicStake;

      // Update persistent values with the new state
      if (!this.playerStateToApplyAtEndOfGameBecauseOfRecovery && parts[i].gameDisplayStateAfterPart) {
        // TODO check this.basicStake!!
        this.updatePersistentValuesFromDisplayState(
          parts[i].gameDisplayStateAfterPart,
          data.BasicStake,
          this.currentMode
        );
      }

      // Update the GameComplete message with the current persistent values
      // The message should be the most recent one added to the queue
      for (let j = this._messageQueue.length - 1; j >= 0; j--) {
        if (this._messageQueue[j].type === 'common:GameCompleteEvent') {
          this._messageQueue[j].persistentValues = this._persistentValues;
          break;
        }
      }
    } else if (type === 'featureSpins') {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.featureSpins = parts[i];
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = data.Parts[i].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings + this._finalWheelWinnings;

      this.addFeatureAwardToQueue();

      this.addFSStartToQueue(parts[i], this.currentMode);
    } else if (type === 'wheel') {
      this._finalWheelWinnings = parts[i].winAmount;
      totalWon += this.processWheel(parts[i], this._finalBaseWinnings);
      if (i === parts.length - 1) {
        this.addGameCompleteToQueue(totalWon);

        // Update persistent values with the new state after wheel
        if (parts[i].gameDisplayStateAfterPart) {
          // TODO check this.basicStake!!
          this.updatePersistentValuesFromDisplayState(
            parts[i].gameDisplayStateAfterPart,
            data.BasicStake,
            this.currentMode
          );
          // this.addPersistentValuesUpdateToQueue(data.BasicStake, this.currentMode);

          // Update the GameComplete message with the current persistent values
          for (let j = this._messageQueue.length - 1; j >= 0; j--) {
            if (this._messageQueue[j].type === 'common:GameCompleteEvent') {
              this._messageQueue[j].persistentValues = this._persistentValues;
              break;
            }
          }
        }
      }
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addFeatureAwardToQueue = function () {
  var message = {};
  message.type = 'game:FeatureAwardEvent';
  this._messageQueue.push(message);
};

GatiServerGame.prototype.transformDisplayStateAfterPart = function (displayState) {
  return {
    green: {
      displayLevelIndex: displayState.eliminationsDisplayLevelIndex,
      eliminationLevel: displayState.eliminationLevel,
    },
    red: {
      displayLevelIndex: displayState.freeSpinsDisplayLevelIndex,
      numFreeSpins: displayState.numFreeSpins,
    },
    gold: {
      displayLevelIndex: displayState.wheelDisplayLevelIndex,
      numWheelUpgrades: displayState.numWheelUpgrades,
    },
    blue: {
      displayLevelIndex: displayState.jpSpinsDisplayLevelIndex,
    },
  };
};

// Helper function to get the displays that have changed
GatiServerGame.prototype.checkDisplayStateChanges = function (currentState, newState) {
  const getDifference = (obj1, obj2) => {
    return Object.fromEntries(
      Object.entries(obj2)
        .map(([key, value]) => {
          if (value && typeof value === 'object' && !Array.isArray(value)) {
            const nestedDiff = getDifference(obj1[key] || {}, value);
            return Object.keys(nestedDiff).length > 0 ? [key, nestedDiff] : null;
          } else {
            return value !== obj1[key] ? [key, value] : null;
          }
        })
        .filter(Boolean)
    );
  };

  const difference = getDifference(currentState, newState);
  return Object.keys(difference).length > 0 ? difference : null;
};

GatiServerGame.prototype.processWheel = function (wheelPart, baseWinnings) {
  // Route to wheel controller
  console.log('GatiServerGame: Processing wheel feature', wheelPart);

  const numWheelUpgrades =
    this._pendingDisplayStateUpdate.postBase.changes?.gold?.numWheelUpgrades ||
    this._currentDisplayState.gold.numWheelUpgrades;

  let wheelWinnings = wheelPart.winAmount;

  const type = this._inBuyABonus ? 'feature:buyBonusWheel' : 'feature:wheel';

  // Get wheel controller instance
  let message = {};
  message.type = type;
  message.data = wheelPart;
  message.data.numWheelUpgrades = numWheelUpgrades;
  message.data.baseWinnings = baseWinnings;
  this._messageQueue.push(message);

  return wheelWinnings;
};

GatiServerGame.prototype.addWinnings = function (winningLinesData, mysteryWildFeature) {
  if (mysteryWildFeature && mysteryWildFeature.isAwarded) {
    mysteryWildFeature.upgradedPayLines.forEach(function (upgradedLine) {
      const upgradedLineId = upgradedLine.winningLine;
      const foundWinningLine = winningLinesData.winningLines.find(function (winningLine) {
        const winningLineId = winningLine.winningLine;
        return winningLineId === upgradedLineId;
      });
      if (foundWinningLine) {
        foundWinningLine.winAmount = upgradedLine.winAmountAfterMultiplier;
      }
    });

    let totalLineWinnings = 0;
    winningLinesData.winningLines.forEach(function (winningLine) {
      return (totalLineWinnings += winningLine.winAmount);
    });
    winningLinesData.totalLineWinnings = totalLineWinnings;
  }

  this.addWinningsToQueue(winningLinesData);
};

GatiServerGame.prototype.removeWildsFromReels = function (reels) {
  const wildId = 9;
  for (let reel = 0; reel < reels.length; ++reel) {
    for (let i = 0; i < reels[reel].symbols.length; ++i) {
      if (reels[reel].symbols[i].value === wildId) {
        reels[reel].symbols[i].value = 0;
      }
    }
  }
};

GatiServerGame.prototype.removeWildsFromAboveBelow = function (message) {
  this.removeWildsFromReels(message.resultPanel.symbolsAbove);
  this.removeWildsFromReels(message.resultPanel.symbolsBelow);
};

GatiServerGame.prototype.addSpinDataToQueue = function (
  event,
  winAmount,
  montezumaBonus,
  trailLevelData,
  freeSpinsData,
  finalFreeSpin,
  shutterData,
  wheelWon
) {
  var message = {};
  message.type = 'spinner:SpinEvent';

  message.lines = event.lines;
  message.isPrePaidGame = this._isPrePaidGame;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  // Only add base win amount if it exists
  message.totalWinnings = winAmount !== undefined ? winAmount : event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  message.finalFreeSpin = finalFreeSpin;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.reelList;
  message.resultPanel.symbolsAbove = event.symbolsAbove;
  message.resultPanel.symbolsBelow = event.symbolsBelow;

  message.montezumaBonus = montezumaBonus;
  message.trailLevelData = trailLevelData;
  message.freeSpinsData = freeSpinsData;
  message.shutterData = shutterData;

  message.winAmountPresent = winAmount;

  message.wheel = this._wheelData;
  message.wheelWon = wheelWon;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  // _currentDisplayState
  //  message.initialDisplayState = JSON.parse(JSON.stringify(this._currentDisplayState));
  message.isWheel = this._isWheel;
  message.isFeatureSpins = this._isFeatureSpins;

  if (!this.inFS) {
    message.pendingDisplayStateUpdate = this._pendingDisplayStateUpdate;
  }

  this._isWheel = false;
  this._isFeatureSpins = false;

  this._messageQueue.push(message);
  return message;
};

GatiServerGame.prototype.getSpinDataGeneric = function (spinEvent, data, nextData, freeSpinsActive, cb) {
  let winAmount = data.winAmount;
  let montezumaBonus = data.montezumaBonus;
  let isCapped = data.winCapped;
  let finalFreeSpin = false;
  let freeSpinsData = undefined;
  let trailLevelData = undefined;
  let shutterData = [];
  let wheelWon = false;

  if (nextData?.type === 'wheel') {
    wheelWon = true;
  }

  if (freeSpinsActive) {
    if (this.freeSpins.spins.length === this.fsCount) {
      finalFreeSpin = true;
    }

    trailLevelData = {
      trailLevelAdded: data.trailLevelAdded,
      trailLevelAtEnd: data.trailLevelAtEnd,
      jackpotTrails: data.jpTrails,
    };

    freeSpinsData = {
      spinsAdded: data.spinsAdded,
      spinsRemaining: data.spinsRemaining,
      winAmount: data.winAmount,
      winAmountSoFar: data.winAmountSoFar,
    };

    isCapped = data.isCapped;
  }

  // Process shutter positions if they exist
  if (data.shutterPositions && data.shutterPositions.shutters) {
    for (let i = 0; i < data.shutterPositions.shutters.length; i++) {
      let shutter = data.shutterPositions.shutters[i];
      let reel = shutter.pos.reel;
      let row = shutter.pos.row;

      // Store the original symbol before swapping
      let originalSymbol = spinEvent.reelList[reel].symbols[row].value;

      // Swap the symbol to present (ID 15)
      spinEvent.reelList[reel].symbols[row].value = 15;

      // Store shutter data for later use
      shutterData.push({
        reel: reel,
        row: row,
        originalSymbol: originalSymbol,
        revealedSymbols: shutter.symbols,
      });
    }
  }

  this.addSpinDataToQueue(
    spinEvent,
    winAmount,
    montezumaBonus,
    trailLevelData,
    freeSpinsData,
    finalFreeSpin,
    shutterData,
    wheelWon,
    data.gameDisplayStateAfterPart
  );

  let winningLinesEvent = data.payLines;

  if (winningLinesEvent.totalLineWinnings > 0) {
    this.addWinnings(winningLinesEvent, data.mysteryWildFeature);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.isCapped = isCapped;
  }

  if (freeSpinsActive) {
    this.fsWinnings += data.winAmount;

    if (this.fsCount < this.freeSpins.spins.length) {
      let spinWinAmount = data.winAmount;
      let winAmountSoFar = data.winAmountSoFar;
      this.addFSDataToQueue({ winAmountSoFar, spinWinAmount });
    } else {
      // is this actually needed, counters are reset on free spins end!
      // this needs to go in at the end of free spins!
      // Update persistent values with the new state after feature spins

      if (this.featureSpins.gameDisplayStateAfterPart) {
        // TODO check this.basicStake!!
        this.updatePersistentValuesFromDisplayState(
          this.featureSpins.gameDisplayStateAfterPart,
          this.basicStake,
          this.currentMode
        );
        // this.addPersistentValuesUpdateToQueue(this.basicStake, this.currentMode);
      }

      this.addFSEndToQueue(this.fsWinnings, isCapped);

      this.addGameCompleteToQueue(this.fsWinnings);

      if (this.playerStateToApplyAtEndOfGameBecauseOfRecovery) {
        this.updatePersistentStateForEndGameWhenRecovery(this.playerStateToApplyAtEndOfGameBecauseOfRecovery);
        this.playerStateToApplyAtEndOfGameBecauseOfRecovery = undefined;
      }

      this.inFS = false;
    }

    cb();
    this.triggerNextMessage();
  } else {
    return winAmount;
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data, nextData) {
  let spinEvent = data.stopWindow;
  let winningLinesEvent = data.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;
  const totalWin = this.getSpinDataGeneric(spinEvent, data, nextData, false, function () {});
  return totalWin;
};

GatiServerGame.prototype.getSpinDataFS = function (data, cb) {
  let thisFsOutcome = this.freeSpins.spins[this.fsCount++];
  if (!thisFsOutcome.shutterPositions) {
    thisFsOutcome.shutterPositions = thisFsOutcome.shutters;
  }
  let spinEvent = thisFsOutcome.stopWindow;

  this.getSpinDataGeneric(spinEvent, thisFsOutcome, null, true, cb);
};

GatiServerGame.prototype.addFSAwardToQueue = function (freespinsAwarded) {
  var message = {};
  message.type = 'spinner:FreeSpinsAwardEvent';
  message.freeSpinsAwarded = freespinsAwarded;
  this._messageQueue.push(message);
};

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== '') {
    console.log('force: ' + this.force);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
  this.cheatAdded = true;
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

// Helper method to check if we're currently processing a custom feature
// GatiServerGame.prototype.isProcessingCustomFeature = function () {
//   const standardFSController = resourceManager.getController('standardFreeSpinsController');

//   return standardFSController && standardFSController.isActive();
// };

// // Override addBalanceEventToQueue to use correct balance during features
// GatiServerGame.prototype.addBalanceEventToQueue = function () {
//   // Check if we're processing a custom feature
//   const processingCustomFeature = this.isProcessingCustomFeature();

//   let balanceToSend = this._balance;

//   // If we're processing custom feature and have the feature balance stored, use that instead
//   if (processingCustomFeature && this._preFeatureBalance !== undefined) {
//     balanceToSend = this._preFeatureBalance;
//   }

//   const message = {
//     type: 'common:BalanceEvent',
//     balance: this._inRewatchMode ? 0 : balanceToSend,
//   };

//   this._messageQueue.push(message);
// };

// replace the libs endGame function so we can update the _endGame vars
GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  if (this.playerStateToApplyAtEndOfGameBecauseOfRecovery) {
    // debugger;
    this.updatePersistentStateForEndGameWhenRecovery(this.playerStateToApplyAtEndOfGameBecauseOfRecovery);
    this.playerStateToApplyAtEndOfGameBecauseOfRecovery = undefined;
  }
  this._endGame = false;
  this.addingRecoveryToQueue = false;
};

GatiServerGame.prototype.isGameModeBonusBuy = function (mode) {
  return mode === 'BONUS_BUY_LOW' || mode === 'BONUS_BUY_HIGH' || mode === 'BONUS_BUY_MYSTERY';
};
